const icon = require('vue-svgicon');
icon.register({
    'linkedin': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" clip-rule="evenodd" d="M4.858 2.78C4.836 1.77 4.113 1 2.94 1S1 1.77 1 2.78c0 .99.744 1.78 1.896 1.78h.022c1.195 0 1.94-.79 1.94-1.78zm-.226 3.187h-3.43v10.304h3.43V5.967zm8.42-.242c2.256 0 3.948 1.473 3.948 4.638v5.908h-3.43V10.76c0-1.385-.496-2.33-1.737-2.33-.948 0-1.512.637-1.76 1.252-.09.22-.113.528-.113.836v5.755H6.53s.046-9.338 0-10.304h3.43v1.459c.455-.702 1.27-1.702 3.091-1.702z"/>`,
    },
});
